//utils
import { shortDateFormat } from '../../../utils/dateFormat';

function OverlappingRecurringShiftsPlan({ userPromptModal, t, dateTimeRules }) {
    if (!userPromptModal.sourceInfo.overlappingRecurringShiftsPlan) return null;

    const { error, plans } = userPromptModal.sourceInfo.overlappingRecurringShiftsPlan;

    return (
        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            <div className="fw-bold text-danger mb-1">
                {error}
            </div>

            <div className="row timelog-grid-time-card">
                <table className="table mt-0" style={{ tableLayout: 'fixed' }}>
                    <thead>
                        <tr>
                            <th className="text-start" style={{ width: '34%' }}>{t('Name')}</th>
                            <th className="text-start" style={{ width: '33%' }}>{t('From date')}</th>
                            <th className="text-start" style={{ width: '33%' }}>{t('To date')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {plans.map(plan => (
                            <tr key={plan.id}>
                                <td className="text-start">
                                    <div className="text-truncate" title={plan.name}>{plan.name}</div>
                                </td>
                                <td className="text-start">{shortDateFormat(plan.start_date, dateTimeRules)}</td>
                                <td className="text-start">{shortDateFormat(plan.end_date, dateTimeRules)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export {
    OverlappingRecurringShiftsPlan
};
